import axios from 'axios';
import { getEndpoint, getRequestHeaders  } from './config'

export default function (destinationId: any, userId: string) {
    return new Promise<any>((resolve, reject) => {
        axios
            .delete(
                getEndpoint('destinations/{id}/users/{userId}', { id: destinationId, userId }),
                getRequestHeaders(true)
            )
            .then(function (response : any) {
                resolve(response.data);
            })
            .catch(function (rs : any) {
                reject(rs);
            });
    });
}